import type { Layer } from "@deck.gl/core"
import { LayerIndex } from "@nova/constants"
import { useWindLayers } from "./wind/windLayers"
import { usePrecipitationLayer } from "./precipitation/precipitationLayers"
import { useRadarLayer } from "./radar/radarLayers"
import { useLightningLayer } from "./lightning/lightningLayers"
import { useLightningStrikesLayer } from "./lightning/lightningStrikesLayers"
import { useWeatherPlayheadClamp } from "./series/weatherTimelineWindow"
import type { MapBackgroundViewType } from "features/map/control/useMapStyles"

export type ZIndexedLayer = { layer: Layer; zIndex: number }

export const useWeatherLayers = (viewType: MapBackgroundViewType) => {
    useWeatherPlayheadClamp()
    const { heatmap, particles } = useWindLayers()
    const { layer: precipitationLayer } = usePrecipitationLayer()
    const { layer: radarLayer } = useRadarLayer()
    const { layer: lightningLayer } = useLightningLayer()
    const { layer: lightningStrikesLayer } = useLightningStrikesLayer(viewType)

    const layers: ZIndexedLayer[] = []
    if (heatmap) layers.push({ layer: heatmap, zIndex: LayerIndex.WeatherHeatmap })
    if (particles) layers.push({ layer: particles, zIndex: LayerIndex.WeatherParticles })
    if (precipitationLayer)
        layers.push({ layer: precipitationLayer, zIndex: LayerIndex.WeatherHeatmap })
    if (radarLayer) layers.push({ layer: radarLayer, zIndex: LayerIndex.WeatherHeatmap })
    if (lightningLayer) layers.push({ layer: lightningLayer, zIndex: LayerIndex.WeatherHeatmap })
    if (lightningStrikesLayer)
        layers.push({ layer: lightningStrikesLayer, zIndex: LayerIndex.WeatherParticles })
    return layers
}
